import { makeStyles } from '@material-ui/styles';

const HEADER_HEIGHT = 64;
const CONTROL_BAR_HEIHGT = 183;

export default makeStyles(theme => ({
  paper: {
    height: '100%',
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      maxWidth: 1280,
      height: 'unset',
      overflow: 'unset',
      minWidth: 800,
      marginBottom: theme.spacing(1),
    },
  },
  header: {
    height: HEADER_HEIGHT,
    position: 'relative',
    padding: 24,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderBottom: `1px solid ${theme.palette.colors.border}`,
  },
  backButton: {
    left: 10,
    position: 'absolute',
  },
  container: {
    width: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
    height: `calc(100% - ${HEADER_HEIGHT + CONTROL_BAR_HEIHGT}px)`,
    [theme.breakpoints.up('mobile')]: {
      border: [1, 'solid', theme.palette.colors.border],
      height: 'unset',
    },
  },
  white: {
    fill: theme.palette.colors.white,
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
  compareButton: {
    width: '100%',
    [theme.breakpoints.up('mobile')]: {
      width: 350,
      marginLeft: theme.spacing(1),
    },
  },
  controlBar: {
    display: 'flex',
    flexDirection: 'column-reverse',
    justifyContent: 'space-between',
    width: '100%',
    borderTop: `1px solid ${theme.palette.colors.border}`,
    height: CONTROL_BAR_HEIHGT,
    padding: theme.spacing(4),
    [theme.breakpoints.up('mobile')]: {
      flexDirection: 'row',
      justifyContent: 'unset',
      marginTop: theme.spacing(6),
      borderTop: 'none',
      padding: 0,
      paddingBottom: theme.spacing(6),
      height: 'unset',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/SummaryPage/useStyles.js